
// Category, Subcategory, and Product Mapping
export const categoriesList = {
    IceCream: {
        "Tub  1  Ltr": [
            {
                "Tub Vanilla - 1 Ltr": {
                    "dealerPrice": "208",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "260",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "1"
                },
            },
            {
                "Tub Strawberry - 1 Ltr": {
                    "dealerPrice": "224",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "280",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "2"
                },
            },
            {
                "Tub Pista - 1 Ltr": {
                    "dealerPrice": "264",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "330",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "3"
                },
            },
            {
                "Tub Alphonso Mango - 1 Ltr": {
                    "dealerPrice": "272",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "340",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "4"
                },
            },
            {
                "Tub Butterscotch - 1 Ltr": {
                    "dealerPrice": "272",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "340",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "5"
                },
            },
            {
                "Tub BlackCurrant - 1 Ltr": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "6"
                },
            },
            {
                "Tub Chocolate - 1 Ltr": {
                    "dealerPrice": "296",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "370",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "7"
                },
            },
            {
                "Tub Spanish Delight - 1 Ltr": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "8"
                },
            },
            {
                "Tub Kesar Badam Pista - 1 Ltr": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "9"
                },
            },
            {
                "Tub Kulfi - 1 Ltr": {
                    "dealerPrice": "304",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "380",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "10"
                },
            },
            {
                "Tub Vanilla Strawberry - 1 Ltr": {
                    "dealerPrice": "224",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "280",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "11"
                },
            },
            {
                "Tub Vanilla Chocolate - 1 Ltr": {
                    "dealerPrice": "264",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "330",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "12"
                },
            },
        ],
        "Tub  1  Ltr - Premium Ice Cream": [
            {
                "Tub Premium Pineapple - 1 Ltr": {
                    "dealerPrice": "264",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "330",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "13"
                },
            },
            {
                "Tub Premium Chikoo - 1 Ltr": {
                    "dealerPrice": "272",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "340",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "14",
                },
            },
            {
                "Tub Fig & Honey - 1 Ltr": {
                    "dealerPrice": "304",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "380",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "15",
                },
            },
            {
                "Tub Premium Jackfruit - 1 Ltr": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "16",
                },
            },
            {
                "Tub Premium Kiwi - 1 Ltr": {
                    "dealerPrice": "304",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "380",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "17",
                },
            },
            {
                "Tub Premium Passion Fruit - 1 Ltr": {
                    "dealerPrice": "304",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "380",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "18",
                },
            },
            {
                "Tub Premium Tender Coconut - 1 Ltr": {
                    "dealerPrice": "352",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "440",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "19",
                },
            },
            {
                "Tub Premium Blueberry - 1 Ltr": {
                    "dealerPrice": "352",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "440",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "20",
                },
            },
        ],
        "FP  (500  ML Tub)": [
            {
                "FP Vanilla - 500 ML": {
                    "dealerPrice": "120",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "150",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "21"
                },
            },
            {
                "FP Strawberry - 500 ML": {
                    "dealerPrice": "128",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "160",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "22"
                },
            },
            {
                "FP Pista - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "23"
                },
            },
            {
                "FP Alphonso Mango - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "24"
                },
            },
            {
                "FP Butterscotch - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "25"
                },
            },
            {
                "FP Black Currant - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "26"
                },
            },
            {
                "FP Chocolate - 500 ML": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "27"
                },
            },
            {
                "FP Spanish Delight - 500 ML": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "28"
                },
            },
            {
                "FP Kesar Badam Pista - 500 ML": {
                    "dealerPrice": "165",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "195",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "29"
                },
            },
            {
                "FP Kulfi - 500 ML": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "30"
                },
            },
        ],
        "FP  (500  ML Tub) -  Premium Ice Cream": [
            {
                "FP Premium Pineapple - 500 ML": {
                    "dealerPrice": "148",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "185",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "31"
                },
            },
            {
                "FP Premium Chikoo - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "32"
                },
            },
            {
                "FP Fig & Honey - 500 ML": {
                    "dealerPrice": "168",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "210",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "33"
                },
            },
            {
                "FP Premium Jackfruit - 500 ML": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "34"
                },
            },
            {
                "FP Premium Kiwi - 500 ML": {
                    "dealerPrice": "168",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "210",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "35"
                },
            },
            {
                "FP Premium Passion Fruit - 500 ML": {
                    "dealerPrice": "168",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "210",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "36"
                },
            },
            {
                "FP Premium Sitaphal - 500 ML": {
                    "dealerPrice": "184",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "230",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "37"
                },
            },
            {
                "FP Premium Tender Coconut - 500 ML": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "38"
                },
            },
            {
                "FP Premium Blueberry - 500 ML": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "39"
                },
            },
            {
                "FP Premium Cheese Strawberry - 500 ML": {
                    "dealerPrice": "312",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "390",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "40"
                },
            },
            {
                "FP Premium Red Velvet - 500 ML": {
                    "dealerPrice": "168",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "210",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "41"
                },
            },
        ],
        "FP (500 ML Tub) - Sorbet": [
            {
                "FP Sorbet Chilly Guava - 500 ML": {
                    "dealerPrice": "159.2",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "199",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "42"
                },
            },
            {
                "FP Sorbet Strawberry - 500 ML": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "43"
                },
            },
            {
                "FP Sorbet Mango - 500 ML": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "44"
                },
            },
        ],
        "1250  ML Ice Cream": [
            {
                "1.25 Ltr Vanilla": {
                    "dealerPrice": "208",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "260",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "45"
                },
            },
        ],
        "Cup": [
            {
                "60 ML Cup Vanilla (18 Nos)": {
                    "dealerPrice": "216",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "270",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "46"
                },
            },
            {
                "40 ML Cup Vanilla (24 Nos)": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "47"
                },
            },
            {
                "Celebro 40 ML Cup Vanilla (24 Nos)": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "48"
                },
            },
        ],

        "Cup with Plastic Lid": [
            {
                "70 ML Cup Chocolate (12 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "49"
                },
            },
            {
                "70 ML Cup Pista (12 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "50"
                },
            },
            {
                "70 ML Cup Strawberry (12 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "51"
                },
            },

        ],
        "Ball": [
            {
                "Ball Vanilla - 70 ML (18 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "52"
                },
            },
            {
                "Strawberry in Strawberry (12 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "53"
                },
            },
            {
                "Mango in Mango (12 Nos)": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "54"
                },
            },
        ],
        "Mini  Tub  -  125  ML": [
            {
                "Mini Tub Strawberry - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "55"
                },
            },
            {
                "Mini Tub Chikoo - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "56"
                },
            },
            {
                "Mini Tub Kiwi - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "57"
                },
            },
            {
                "Mini Tub 21 Love - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "58"
                },
            },
            {
                "Mini Tub Alphonso Mango - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "59"
                },
            },
            {
                "Mini Tub JackFruit - 125 ML (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "60"
                },
            },
            {
                "Mini Tub Sitaphal - 125 ML (6 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "61"
                },
            },
            {
                "Mini Tub Tender Coconut - 125 ML (6 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "62"
                },
            },
            {
                "Mini Tub Blueberry - 125 ML (6 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "63"
                },
            },
        ],
        "Richy": [
            {
                "Richy (10 Nos)": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "64"
                },
            },
            {
                "Baby Richy (16 Nos)": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "65"
                },
            },
        ],
        "Special Sundae": [
            {
                "Special Sundae Chocolate (6 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "66"
                },
            },
            {
                "Special Sundae Strawberry (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "67"
                },
            },
            {
                "Special Sundae Pista (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "68",
                },
            },
            {
                "Special Sundae Blackcurrant (6 Nos)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "69"
                },
            },
        ],
        "Merry  Cone - 120  ML": [
            {
                "Merrycone Chocolate (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "70"
                },
            },
            {
                "Merrycone ButterScotch (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "71"
                },
            },
            {
                "Merrycone Vanilla (16 Nos)": {
                    "dealerPrice": "576",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "720",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "72"
                },
            },
        ],
        "Merry  Cone - Fruit Filled Cone (Pencil Filling) 120  ML": [
            {
                "Fruit Filled Cone Strawberry (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "73"
                },
            },
            {
                "Fruit Filled Cone Pineapple (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "74"
                },
            },
            {
                "Fruit Filled Cone Passion Fruit (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "75"
                },
            },
            {
                "Fruit Filled Cone Kiwi (16 Nos)": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "76"
                },
            },
            {
                "Fruit Filled Cone Blueberry (16 Nos)": {
                    "dealerPrice": "768",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "960",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "77"
                },
            },
        ],
        "Mini  Merry  Cone - 45  ML": [
            {
                "Mini Merrycone Vanilla (20 Nos)": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "78"
                },
            },
            {
                "Mini Merrycone Chocolate (20 Nos)": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "79"
                },
            },
            {
                "Mini Merrycone Pista (20 Nos)": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "80"
                },
            },
        ],
        "Bar": [
            {
                "Choco Bar (20 Nos)": {
                    "dealerPrice": "560",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "700",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "81"
                },
            },
            {
                "Alphonso Mango Bar (20 Nos)": {
                    "dealerPrice": "700",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "875",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "82"
                },
            },
            {
                "Kulfi Bar (20 Nos)": {
                    "dealerPrice": "800",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1000",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "83"
                },
            },
            {
                "Majestica Bar Dark Chocolate with Butterscotch (12 Nos)": {
                    "dealerPrice": "672",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "840",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "84"
                },
            },
            {
                "Ripple Bar White Chocolate with Strawberry (12 Nos)": {
                    "dealerPrice": "672",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "840",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "85"
                },
            },
            {
                "Velvetine Bar (12 Nos)": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "86"
                },
            },
            {
                "MINTIMATE Bar (12 Nos)": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "296"
                },
            },
        ],
        "MILK BAR": [
            {
                "Milk Bar Pista (25 Nos)": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "87"
                },
            },
        ],
        "FRUIT BAR": [
            {
                "Fruit Bar Strawberry (25 Nos)": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "88"
                },
            },
            {
                "Fruit Bar Pineapple (25 Nos)": {
                    "dealerPrice": "300",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "375",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "89"
                },
            },
            {
                "Fruit Bar Mango (25 Nos)": {
                    "dealerPrice": "500",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "625",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "90"
                },
            },
            {
                "Fruit Bar Chilly Guava (25 Nos)": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "91"
                },
            },
        ],
        "Combo  Pack": [
            {
                "1+1 Combo Pack Vanilla Strawberry - 750 ML": {
                    "dealerPrice": "264",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "330",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "92"
                },
            },
            {
                "1+1 Combo Pack Vanilla Pista - 750 ML": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "93"
                },
            },
            {
                "1+1 Combo Pack Vanilla Butterscotch - 750 ML": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "94"
                },
            },
            {
                "1+1 Combo Pack Vanilla Mango - 750 ML": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "95"
                },
            },
        ],
        "Other Items": [
            {
                "Matka Kulfi (12 Nos)": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "96"
                },
            },
            {
                "Cassatta Queen (10 Nos)": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "97"
                },
            },
            {
                "Puttu Ice Cream": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "98"
                },
            },
            {
                "Kiwi Matka Kulfi (6 Nos)": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "297"
                },
            },
        ],
        "ice cream cake": [
            {
                "icecream cake truffle treat": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "96"
                },
            },
            {
                "ice cream cake cream caramal": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "97"
                },
            },
            {
                "tub premium sitaphal - 1 ltr": {
                    "dealerPrice": "344",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "430",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "98"
                },
            },
            {
                "Mini tub french vanilla zero sugar": {
                    "dealerPrice": "432",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "540",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "297"
                },
            },
        ],
        "Milk  Lolly": [
            {
                "Big Lolly Pineapple (12 Nos)": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "99"
                },
            },
            {
                "Big Lolly Pista (12 Nos)": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "100"
                },
            },
            {
                "Big Lolly Mango (12 Nos)": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "101"
                },
            },
            {
                "Big Lolly Strawberry (12 Nos)": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "102"
                },
            },
        ],
        "2  Ltr Ice Cream": [
            {
                "2 Ltr Pack Vanilla": {
                    "dealerPrice": "352",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "440",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "103"
                },
            },
            {
                "2 Ltr Pack Strawberry": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "104"
                },
            },
            {
                "2 Ltr Pack Pista": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "105"
                },
            },
            {
                "2 Ltr Pack Alphonso Mango": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "106"
                },
            },

            {
                "2 Ltr Pack Butterscotch": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "107"
                },
            },
            {
                "2 Ltr Pack Chocolate": {
                    "dealerPrice": "460",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "575",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "108"
                },
            },
            {
                "2 Ltr Pack Spanish Delight": {
                    "dealerPrice": "432",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "540",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "109"
                },
            },
        ],
        "4  Ltr Ice Cream": [
            {
                "4 LTR Vanilla": {
                    "dealerPrice": "517.95",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "640",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "110"
                },
            },
            {
                "4 LTR Strawberry": {
                    "dealerPrice": "598.88",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "740",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "111"
                },
            },
            {
                "4 LTR Orange": {
                    "dealerPrice": "598.88",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "740",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "112"
                },
            },
            {
                "4 LTR Coffee": {
                    "dealerPrice": "598.88",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "740",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "113"
                },
            },
            {
                "4 LTR Alphonso Mango": {
                    "dealerPrice": "696",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "114"
                },
            },
            {
                "4 LTR Pista": {
                    "dealerPrice": "728.37",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "910",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "115"
                },
            },
            {
                "4 LTR Butterscotch": {
                    "dealerPrice": "736.46",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "910",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "116"
                },
            },
            {
                "4 LTR Spanish Delight": {
                    "dealerPrice": "760.74",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "940",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "117"
                },
            },
            {
                "4 LTR Chocolate": {
                    "dealerPrice": "736.46",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "910",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "118"
                },
            },
            {
                "4 LTR Black Currant": {
                    "dealerPrice": "793.11",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "980",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "119"
                },
            },
            {
                "4 LTR Kesar Badam Pista": {
                    "dealerPrice": "809.3",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1000",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "120"
                },
            },
            {
                "4 LTR Kulfi": {
                    "dealerPrice": "882.14",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1090",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "121"
                },
            },
            {
                "4 LTR Vanilla Strawberry": {
                    "dealerPrice": "598.88",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "740",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "122"
                },
            },
            {
                "4 LTR Vanilla Chocolate": {
                    "dealerPrice": "736.46",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "910",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "123"
                },
            },
            {
                "Celebro 4 Ltr Vanilla": {
                    "dealerPrice": "496",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "620",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "124"
                },
            },
        ],
        "4  Ltr Premium  Ice Cream": [
            {
                "4 LTR Premium Pineapple": {
                    "dealerPrice": "704.09",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "870",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "125"
                },
            },
            {
                "4 LTR Fig & Honey": {
                    "dealerPrice": "814.67",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1040",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "126"
                },
            },
            {
                "4 LTR Premium Chikoo": {
                    "dealerPrice": "849.77",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "127"
                },
            },
            {
                "4 LTR Premium Guava": {
                    "dealerPrice": "849.77",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "128"
                },
            },
            {
                "4 LTR Premium JackFruit": {
                    "dealerPrice": "849.77",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "129"
                },
            },
            {
                "4 LTR Premium Kiwi": {
                    "dealerPrice": "938.79",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1160",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "130"
                },
            },
            {
                "4 LTR Premium Passion Fruit": {
                    "dealerPrice": "938.79",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1160",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "131"
                },
            },
            {
                "4 LTR Premium Sitaphal": {
                    "dealerPrice": "1011.63",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "132"
                },
            },
            {
                "4 LTR Premium Tender Coconut": {
                    "dealerPrice": "1092.56",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "133"
                },
            },
            {
                "4 LTR Premium Blueberry": {
                    "dealerPrice": "1133.02",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "134"
                },
            },
            {
                "4 Ltr Premium Cheese Strawberry": {
                    "dealerPrice": "2025",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "2500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "135"
                },
            },
        ],
        "BIG CUP 50 ML": [
            {
                "Big Cup Vanilla * 24": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "136"
                }
            },
            {
                "Big Cup Strawberry * 24": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "137"
                }
            }
        ],
        "COUPLE PACK": [
            {
                "Couple Pack Vanilla": {
                    "dealerPrice": "60",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "75",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "138"
                }
            },
            {
                "Couple Pack Strawberry": {
                    "dealerPrice": "64",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "80",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "139"
                }
            }
        ],
        "FAMILY PACK 500 ML TUB": [
            {
                " 500 Ml FP Vanilla": {
                    "dealerPrice": "112",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "140",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "140"
                }
            },
            {
                " 500 Ml FP Strawberry": {
                    "dealerPrice": "120",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "150",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "141"
                }
            },
            {
                " 500 Ml FP Pistachio": {
                    "dealerPrice": "144",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "180",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "142"
                }
            },
            {
                "  500 Ml FP Butterscotch": {
                    "dealerPrice": "144",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "180",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "143"
                }
            },
            {
                " 500 Ml FP Alphonso Mango": {
                    "dealerPrice": "144",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "180",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "144"
                }
            },
            {
                " 500 Ml FP Rich Coffee": {
                    "dealerPrice": "136",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "170",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "145"
                }
            },
            {
                " 500 Ml FP Sweet Orange": {
                    "dealerPrice": "136",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "170",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "146"
                }
            },
            {
                " 500 Ml FP Pineapple": {
                    "dealerPrice": "144",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "180",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "147"
                }
            },
            {
                " 500 Ml FP Rich Chocolate": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "148"
                }
            },
            {
                " 500 Ml FP Blackcurrant": {
                    "dealerPrice": "144",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "180",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "149"
                }
            },
            {
                " 500 Ml FP Spanish Delight": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "150"
                }
            },
            {
                " 500 Ml FP Fig N Honey": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "151"
                }
            },
            {
                " 500 Ml FP Cashew Kheer": {
                    "dealerPrice": "152",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "190",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "152"
                }
            },
            {
                " 500 Ml FP Arabian Delight": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "153"
                }
            },
            {
                " 500 Ml FP Rosted Almond": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "154"
                }
            },
            {
                " 500 Ml FP Fresh Chiku": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "155"
                }
            },
            {
                " 500 Ml FP Indian Jack Fruit": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "156"
                }
            },
            {
                " 500 Ml FP Real Passion Fruit": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "157"
                }
            },
            {
                " 500 Ml FP Tender Coconut": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "158"
                }
            },
            {
                " 500 Ml FP Blueberry": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "159"
                }
            },
             {
                " 500 Ml FP Avocado": {
                    "dealerPrice": "184",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "230",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "324"
                }
            }
        ],
        "OFFER PACK 1000 ML": [
            {
                "vanilla sterberry ripple-1000ml": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "160"
                }
            },
            {
                "vanilla choclate repple-1000": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "161"
                }
            }
        ],
        "ROYAL CONE 120 ML": [
            {
                "Royal Cone Chocolate * 12": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "162"
                }
            },
            {
                "Royal Cone Butter Scotch * 12": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "163"
                }
            },
            {
                "Royal Cone Arabian Delight * 12": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "164"
                }
            },
            {
                "Royal Cone Vanilla * 12": {
                    "dealerPrice": "432",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "540",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "165"
                }
            },
            {
                "Royal Cone Spanish Delight * 12": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "166"
                }
            },
            {
                "Royal Cone Black Currant * 12": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "167"
                }
            }
        ],
        "CRUNCHY CONE 80 ML": [
            {
                "Crunchy Cone Butterscotch*12": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "168"
                }
            },
            {
                "Crunchy Cone Strawberry*12": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "169"
                }
            },
            {
                "Crunchy Cone Pista *12": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "170"
                }
            }
        ],
        "WONDER CONE 40 ML": [
            {
                "Wonder Cone Butterscotch": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "171"
                }
            },
            {
                "Wonder Cone Vanilla": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "172"
                }
            },
            {
                "Wonder Cone Chocolate": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "173"
                }
            }
        ],
        "SUNDAE": [
            {
                "Fruit Sundae 120 ml * 8": {
                    "dealerPrice": "224",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "280",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "174"
                }
            },
            {
                "Mini Sundae Cover * 12": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "175"
                }
            },
            {
                "Mutka Kulfi 100 ml * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "176"
                }
            }
        ],
        "STICK ITEMS": [
            {
                "CHOCOBAR X20": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "177"
                }
            },
            {
                "MANGO BAR X 20": {
                    "dealerPrice": "560",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "700",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "178"
                }
            },
            {
                "KULFI ALMOND X 20": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "179"
                }
            },
            {
                "White Chocobar *20": {
                    "dealerPrice": "560",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "700",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "180"
                }
            },
            {
                "Nutty bar *20": {
                    "dealerPrice": "640",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "800",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "181"
                }
            }
        ],
        "CASSATA": [
            {
                "Royal Cassata Slice 100 ml * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "182"
                }
            }
        ],
        "FUN TREAT": [
            {
                "Fun Treat Chocoripple * 6": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "183"
                }
            },
            {
                "Fun Treat Arabian Delight * 6": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "184"
                }
            },
            {
                "Fun Treat Vanilla * 6": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "185"
                }
            },
            {
                "Fun Treat Strawberry * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "186"
                }
            },
            {
                "Fun Treat Pistachio * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "187"
                }
            }
        ],
        "CANDY X20": [
            {
                "Candy Pink Guva": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "188"
                }
            },
            {
                "Candy Watermelon": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "189"
                }
            },
            {
                "Candy Juicy Mango": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "190"
                }
            },
            {
                "Candy Pineapple": {
                    "dealerPrice": "160",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "200",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "191"
                }
            }
        ],
        "MFIC": [
            {
                "Mangobar Pouch": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "192"
                }
            },
            {
                "Chocobar Pouch": {
                    "dealerPrice": "25",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "31.25",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "193"
                }
            }
        ],
        "BABINOZ": [
            {
                "Mini Cone Butterscotch": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "194"
                }
            },
            {
                "Mini chocobar": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "195"
                }
            }
        ],
        "MELVIN BULK": [
            {
                "Melvin Bulk 4 Ltr Vanilla": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "196"
                }
            },
            {
                "Melvin Bulk 4 Ltr Strawberry": {
                    "dealerPrice": "304",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "380",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "197"
                }
            },
            {
                "Melvin Bulk 4 Ltr Pistachio": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "198"
                }
            },
            {
                "Melvin Bulk 4 Ltr Butterscotch": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "199"
                }
            },
            {
                "Melvin Bulk 4 Ltr Chocolate": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "200"
                }
            },
            {
                "Melvin Bulk 4 Ltr Mango": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "201"
                }
            },
            {
                "Melvin Bulk 4 Ltr Blackcurrant": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "202"
                }
            }
        ],
        "PAPER PACK 750ml": [
            {
                " Paper Pack Vanilla": {
                    "dealerPrice": "104",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "130",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "203"
                }
            },
            {
                "Paper Pack Strawberry": {
                    "dealerPrice": "112",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "140",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "204"
                }
            }
        ],
        "RICHY CONE": [
            {
                "Richy Cone Chocolate": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "205"
                }
            },
            {
                "Richy Cone Butterscotch": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "206"
                }
            }
        ],
        "FUNTWIST": [
            {
                "Funtwist * Mango": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "207"
                }
            },
            {
                "Funtwist * Pista": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "208"
                }
            }
        ],
        "BIG CUP 70 ML": [
            {
                "Big Cup Strawberry * 24": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "209"
                }
            },
            {
                "Big Cup Butterscotch*24": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "210"
                }
            },
            {
                "Big Cup Pista *24": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "211"
                }
            },
            {
                "Big Cup Strawbeery *18": {
                    "dealerPrice": "216",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "270",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "295"
                }
            },
            {
                "Big Cup Choclate *18": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "314"
                }
            },
            {
                "Big Cup Butterscotch*18": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "315"
                }
            },
            {
                "Big Cup Pistachio*18": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "316"
                }
            }
        ],
        "PUTTU ICE CREAM 600 ML": [
            {
                "Puttu Ice Cream": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "72000",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "212"
                }
            }
        ],
        "BALLS": [
            {
                "Strawberry Ball * 12": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "213"
                }
            },
            {
                "Mango Ball * 12": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "214"
                }
            },
            {
                "Vanilla Ball * 20": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "215"
                }
            }
        ],
        "MAGIC FUNDOO": [
            {
                "Magic Fundoo Mango * 6": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "216"
                }
            },
            {
                "Magic Fundoo Orange * 6": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "217"
                }
            },
            {
                "Magic Fundoo Pineapple * 6": {
                    "dealerPrice": "192",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "240",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "218"
                }
            }
        ],
        "EXOTIC PACK 100 ML TUB": [
            {
                "Exotic Pack Roasted Almond * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "219"
                }
            },
            {
                "Exotic Pack Fig N Honey * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "220"
                }
            },
            {
                "Exotic Pack Rich Coffee * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "221"
                }
            },
            {
                "Exotic Pack Real Passion Fruit * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "222"
                }
            },
            {
                "Exotic Pack Fresh Chiku * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "223"
                }
            },
            {
                "Exotic Pack Indian Jack Fruit * 6": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "224"
                }
            },
            {
                "Exotic Pack Black Currant * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "225"
                }
            },
            {
                "Exotic Pack Arabian Delight * 6": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "226"
                }
            },
            {
                "Exotic Pack Tender Coconut * 6": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "227"
                }
            },
            {
                "Exotic Pack Blueberry * 6": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "228"
                }
            },
            {
                "Exotic Pack Belgium Dream * 6": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "229"
                }
            }
        ],
        "PARTY PACK 1000 ML TUB": [
            {
                "Party Pack 1Ltr tub Vanilla": {
                    "dealerPrice": "200",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "250",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "230"
                }
            },
            {
                "Party Pack 1Ltr tub Strawberry": {
                    "dealerPrice": "208",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "260",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "231"
                }
            },
            {
                "Party Pack 1Ltr tub Pistachio": {
                    "dealerPrice": "256",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "320",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "232"
                }
            },
            {
                "Party Pack 1Ltr tub Butterscotch": {
                    "dealerPrice": "256",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "320",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "233"
                }
            },
            {
                "Party Pack 1Ltr tub Alphonso Mango": {
                    "dealerPrice": "256",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "320",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "234"
                }
            },
            {
                "Party Pack 1Ltr tub Rich Coffee": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "235"
                }
            },
            {
                "Party Pack 1Ltr tub Sweet Orange": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "236"
                }
            },
            {
                "Party Pack 1Ltr tub Pineapple": {
                    "dealerPrice": "256",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "320",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "237"
                }
            },
            {
                "Party Pack 1Ltr tub Rich Chocolate": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "238"
                }
            },
            {
                "Party Pack 1Ltr tub Blackcurrant": {
                    "dealerPrice": "256",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "320",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "239"
                }
            },
            {
                "Party Pack 1Ltr tub Spanish Delight": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "240"
                }
            },
            {
                "Party Pack 1Ltr tub Fig N Honey": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "241"
                }
            },
            {
                "Party Pack 1Ltr tub Cashew Kheer": {
                    "dealerPrice": "280",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "242"
                }
            },
            {
                "Party Pack 1Ltr tub Arabian Delight": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "243"
                }
            },
            {
                "Party Pack 1Ltr tub Rosted Almond": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "244"
                }
            },
            {
                "Party Pack 1Ltr tub Fresh Chiku": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "245"
                }
            },
            {
                "Party Pack 1Ltr tub Indian Jack Fruit": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "246"
                }
            },
            {
                "Party Pack 1Ltr tub Real Passion Fruit": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "247"
                }
            },
            {
                "Party Pack 1Ltr tub Tender Coconut": {
                    "dealerPrice": "336",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "420",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "248"
                }
            }
        ],
        "BULK PACK 4000 ML": [
            {
                " Bulk 4 Ltr Vanilla": {
                    "dealerPrice": "512",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "640",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "249"
                }
            },
            {
                "Bulk 4 Ltr Strawberry": {
                    "dealerPrice": "576",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "720",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "250"
                }
            },
            {
                "Bulk 4 Ltr Pistachio": {
                    "dealerPrice": "688",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "251"
                }
            },
            {
                "Bulk 4 Ltr Butterscotch": {
                    "dealerPrice": "688",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "252"
                }
            },
            {
                "Bulk 4 Ltr Alphonso Mango": {
                    "dealerPrice": "688",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "253"
                }
            },
            {
                "Bulk 4 Ltr Rich Coffee": {
                    "dealerPrice": "688",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "254"
                }
            },
            {
                "Bulk 4 Ltr Sweet Orange": {
                    "dealerPrice": "688",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "860",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "255"
                }
            },
            {
                "Bulk 4 Ltr Pineapple": {
                    "dealerPrice": "720",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "900",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "256"
                }
            },
            {
                "Bulk 4 Ltr Rich Chocolate": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "257"
                }
            },
            {
                "Bulk 4 Ltr Blackcurrant": {
                    "dealerPrice": "720",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "900",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "258"
                }
            },
            {
                "Bulk 4 Ltr Spanish Delight": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "259"
                }
            },
            {
                "Bulk 4 Ltr Fig N Honey": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "260"
                }
            },
            {
                "Bulk 4 Ltr Cashew Kheer": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "261"
                }
            },
            {
                "Bulk 4 Ltr Arabian Delight": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "262"
                }
            },
            {
                "Bulk 4 Ltr Rosted Almond": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "263"
                }
            },
            {
                "Bulk 4 Ltr Fresh Chiku": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "264"
                }
            },
            {
                "Bulk 4 Ltr Indian Jack Fruit": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "265"
                }
            },
            {
                "Bulk 4 Ltr Real Passion Fruit": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "266"
                }
            },
            {
                "Bulk 4 Ltr Tender Coconut": {
                    "dealerPrice": "1134",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "267"
                }
            },
            {
                "Bulk 4 Ltr Blueberry": {
                    "dealerPrice": "1215",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "268"
                }
            },
            {
                "Bulk 4 Ltr Cookies N Cream": {
                    "dealerPrice": "840",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1050",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "269"
                }
            },
            {
                "Bulk 4 Ltr Kulfi": {
                    "dealerPrice": "920",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1150",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "270"
                }
            },
            {
                "Bulk 4 Ltr AVOCADO": {
                    "dealerPrice": "1093",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1350",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "323"
                }
            }
        ],
        "BUY 1 GET 1 COMBO": [
            {
                "Vanilla + Arabian Delight": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "271"
                }
            },
            {
                "Vanilla + Cashew Kheer": {
                    "dealerPrice": "240",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "300",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "272"
                }
            },
            {
                "Vanilla + Butterscotch": {
                    "dealerPrice": "224",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "280",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "273"
                }
            },
            {
                "Vanilla + Mango": {
                    "dealerPrice": "224",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "280",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "274"
                }
            },
            {
                "Vanilla + Strawberry": {
                    "dealerPrice": "208",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "260",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "275"
                }
            }
        ],
        "SIPUP": [
            {
                "Sipup Vanilla": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "276"
                }
            },
            {
                "Sipup Strawberry": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "277"
                }
            },
            {
                "Sipup Pistachio": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "278"
                }
            },
            {
                "Sipup Chikoo": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "279"
                }
            },
            {
                "Sipup Chocolate": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "280"
                }
            },
            {
                "Sipup Mango": {
                    "dealerPrice": "96",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "120",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "281"
                }
            }
        ],
        "REGULAR BULK": [
            {
                "Regular Bulk Vanilla": {
                    "dealerPrice": "360",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "450",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "282"
                }
            },
            {
                "Regular Bulk Strawberry": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "283"
                }
            },
            {
                "Regular Bulk Pistachio": {
                    "dealerPrice": "496",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "620",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "284"
                }
            },
            {
                "Regular Bulk Butterscotch": {
                    "dealerPrice": "496",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "620",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "285"
                }
            },
            {
                "Regular Bulk Chocolate": {
                    "dealerPrice": "512",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "640",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "286"
                }
            },
            {
                "Regular Bulk Spanish Delight": {
                    "dealerPrice": "544",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "680",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "287"
                }
            },
            {
                "4 LTR Melvenis Blank Currant": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "500",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "298"
                },
            },
        ],
        "MFIC BULK": [
            {
                "Mfic Bulk Vanilla": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "288"
                }
            },
            {
                "Mfic Bulk Strawberry": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "289"
                }
            }
        ],
        "NEW ARRIVALS": [
            {
                "Dream Icecream": {
                    "dealerPrice": "399.2",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "499",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "290"
                }
            },
            {
                "Premium Mini Chocobar": {
                    "dealerPrice": "400",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "25",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "291"
                }
            },
            {
                "Rocket kulfi-12": {
                    "dealerPrice": "384",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "480",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "292"
                }
            }
        ],
        "RIPPLE": [
            {
                "Babinoz ball": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "15",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "293"
                }
            },
            {
                "Strawberry Ripple": {
                    "dealerPrice": "0",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "0",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "294"
                }
            },
        ],
        "IQF (Individually Quick Frozen)": [
            {
                "IQF Blueberry 1Kg": {
                    "dealerPrice": "730.25",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "730.25",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "299"
                }
            },
            {
                "IQF Black Currant 1Kg": {
                    "dealerPrice": "830.3",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "830.3",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "300"
                }
            },
            {
                "IQF Blackberry 1Kg": {
                    "dealerPrice": "1093.65",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "1093.65",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "301"
                }
            },
            {
                "IQF Cranberry 1Kg": {
                    "dealerPrice": "719.9",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "719.9",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "302"
                }
            },
            {
                "IQF Raspberry 1Kg": {
                    "dealerPrice": "1606.55",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "1606.55",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "303"
                }
            },
            {
                "IQF Red Currant 1Kg": {
                    "dealerPrice": "451.95",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "451.95",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "304"
                }
            },
            {
                "IQF Sweet Cherry 1Kg": {
                    "dealerPrice": "698.05",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "698.05",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "305"
                }
            },
            {
                "IQF Sour Cherry 1Kg": {
                    "dealerPrice": "548",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "548",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "306"
                }
            },
            {
                "Strawberry Fruit 1Kg": {
                    "dealerPrice": "299",
                    "productDescription": "product is very nice",
                    "gstPercentage": 5,
                    "sellingPrice": "299",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "307"
                }
            },
        ],
        "Frozen Pulp": [
            {
                "Mango Pulp 1Kg": {
                    "dealerPrice": "308.10",
                    "productDescription": "product is very nice",
                    "gstPercentage": 12,
                    "sellingPrice": "308.10",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "308"
                }
            },
            {
                "Guava Pulp 1Kg": {
                    "dealerPrice": "165.90",
                    "productDescription": "product is very nice",
                    "gstPercentage": 12,
                    "sellingPrice": "165.90",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "309"
                }
            },

        ],
        "Mercelys": [
            {
                "ChocoBar 25Nos Mercelys": {
                    "dealerPrice": "700",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "875",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "310"
                }
            },
            {
                "Alphonso Mango Bar (25 Nos)": {
                    "dealerPrice": "700",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "875",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "311"
                }
            },
            {
                "Kulfi Bar (25 Nos)": {
                    "dealerPrice": "800",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "1000",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "312"
                }
            },
            {
                "Castard Apple Puree 1LTR": {
                    "dealerPrice": "310",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "310",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "313"
                }
            },
        ],
        "Kiwi New Product": [
            {
                "Kiwi Mini ChocoBar [30ML, 20NOS]": {
                    "dealerPrice": "320",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "400",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "317",
                    "mrp": "20"
                }
            },
            {
                "Babinos Richy Cone Chocolate 12 Nos": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "318",
                    "mrp":  "30"
                }
            },
            {
                "Mini Tub No Added Surar French Vanilla-125 M (6No)": {
                    "dealerPrice": "336",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "420",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "319",
                    "mrp":  "70"
                }
            },
            {
                "Babinoz Richy Cone Butterstoch (12No)": {
                    "dealerPrice": "288",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "360",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "320",
                    "mrp":  "30"
                }
            }
        ],
         "MFIC Sticks": [
            {
                "Mango Bar - [20NOS]": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "321",
                    "mrp": "20"
                }
            },
             {
                "Choco Bar - [20NOS]": {
                    "dealerPrice": "480",
                    "productDescription": "product is very nice",
                    "gstPercentage": 18,
                    "sellingPrice": "600",
                    "stockType": "Available",
                    "designName": "Unique",
                    "_id": "322",
                    "mrp": "20"
                }
            },
           
        ],

    },
    Milk: {
        "Full Cream": ["Pure Full Cream Milk", "Organic Full Cream"],
        "Skimmed": ["Low Fat Milk", "Zero Fat Delight"],
    },
    Gas: {
        "LPG": ["Household LPG", "Commercial LPG"],
        "CNG": ["Automotive CNG", "Industrial CNG"],
    },
};

